import { Form } from "react-bootstrap";
import DefaultUpDownWidget from "@rjsf/core/lib/components/widgets/UpDownWidget";

export const UpDownWidget = props => (
    <Form.Group className="mb-0">
        <Form.Label className={props.rawErrors ? "text-danger" : ""}>{props.label}</Form.Label>
        <DefaultUpDownWidget {...props} />
    </Form.Group>
);
